/**
 * Check alphaId in aswparam object
 * @param {Array} productAlphaIds List of alphaIds from product
 * @param {object} aswparamObject Aswparam object
 * @returns {boolean}
 */
export default (productAlphaIds = [], aswparamObject = {}) => {
	const regex = new RegExp(productAlphaIds.join('|'));
	return regex.test(aswparamObject.p_acp);
};
